
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

import UsedCarsPage from '../pages/used-cars/page';
import RenewableEnergyPage from '../pages/renewable-energy/page';
import WebDevelopmentPage from '../pages/web-development/page';
import RealEstatePage from '../pages/real-estate/page';
import EnergyStoragePage from '../pages/energy-storage/page';
import CompanyPage from '../pages/company/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
  {
    path: '/used-cars',
    element: <UsedCarsPage />,
  },
  {
    path: '/renewable-energy',
    element: <RenewableEnergyPage />,
  },
  {
    path: '/web-development',
    element: <WebDevelopmentPage />,
  },
  {
    path: '/real-estate',
    element: <RealEstatePage />,
  },
  {
    path: '/energy-storage',
    element: <EnergyStoragePage />,
  },
  {
    path: '/company',
    element: <CompanyPage />,
  },
];

export default routes;
